import { memo } from 'react'

import { observer } from 'mobx-react'

import Button from '@material-ui/core/Button'
import SaveIcon from '@material-ui/icons/Save'

import { isTenantSmava } from 'utils/url'

interface SaveButtonProps {
  onClick: () => void
}

const SaveButton = observer(({ onClick }: SaveButtonProps) => {
  const isSmava = isTenantSmava()

  return (
    <Button
      size="large"
      fullWidth
      id="save-button"
      name="save-button"
      variant={isSmava ? 'outlined' : 'contained'}
      color="primary"
      startIcon={<SaveIcon />}
      onClick={onClick}
    >
      Speichern
    </Button>
  )
})

export default memo(SaveButton)
